import React from 'react'

import { reverse } from 'named-urls'
import moment from 'moment'

import { Typography, makeStyles } from '@material-ui/core'

import { routes } from 'routes'
import { DotStatus } from 'components'
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from 'components/Table'
import helpers from 'helpers'
import usePermissions from 'hooks/usePermissions'

import styles from './styles'

const useStyles = makeStyles(styles)

const TableRowContract = ({ contract, ...rest }) => {
  const classes = useStyles()

  return (
    <TableRow {...rest}>
      <TableCell>{contract.id}</TableCell>
      <TableCell>{contract.code}</TableCell>
      <TableCell className={classes.tableCellCustomer}>
        <Typography noWrap>
          <Typography component="span" variant="body2">
            Nome:
          </Typography>{' '}
          {contract.customer.name}
        </Typography>
        <Typography noWrap>
          <Typography component="span" variant="body2">
            Email:
          </Typography>{' '}
          {contract.customer.email}
        </Typography>
        <Typography noWrap>
          <Typography component="span" variant="body2">
            Documento:
          </Typography>{' '}
          {helpers.people.formatMainDocument(contract.customer)}
        </Typography>
      </TableCell>
      <TableCell>
        <div>
          <Typography component="span" variant="body2">
            Dia de vencimento:
          </Typography>{' '}
          {contract.dayExpiration}
        </div>
        <div>
          <Typography component="span" variant="body2">
            Data de criação:
          </Typography>{' '}
          {moment(contract.createdAt)
            .utc(false)
            .format('DD/MM/YYYY')}
        </div>
        {contract.status === 'active' ? (
          <div>
            <Typography component="span" variant="body2">
              Data de ativação:
            </Typography>{' '}
            {moment(contract.dayActivation)
              .utc(false)
              .format('DD/MM/YYYY')}
          </div>
        ) : (
          <div></div>
        )}
      </TableCell>
      <TableCell>{helpers.contracts.chargeType(contract)}</TableCell>
      <TableCell align="center">
        <DotStatus
          statusName={helpers.contracts.status(contract.status)}
          statusTag={contract.status}
          entity="contract"
        />
      </TableCell>
    </TableRow>
  )
}

const ContractsTable = ({ contracts, isLoading }) => {
  const permissions = usePermissions()
  const permittedShowContract = permissions.permitted('show_contract')

  return (
    <Table
      size="medium"
      emptyMessage="Nenhuma assinatura encontrada"
      isLoading={isLoading}
      noWrap
    >
      <TableHead>
        <TableRow>
          <TableCell>Identificador</TableCell>
          <TableCell>Código</TableCell>
          <TableCell bodySkeletonHeight={60}>Cliente</TableCell>
          <TableCell bodySkeletonHeight={40}>Datas da assinatura</TableCell>
          <TableCell>Tipo de cobrança</TableCell>
          <TableCell align="center">Status</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {contracts &&
          contracts.map(contract => (
            <TableRowContract
              key={contract.id}
              contract={contract}
              pointer={permittedShowContract}
              to={
                permittedShowContract &&
                reverse(routes.contracts.show, { contractId: contract.id })
              }
              hover
            />
          ))}
      </TableBody>
    </Table>
  )
}

export default ContractsTable
